// Filter state shared by FilterBar, CreateCollectionModal and the dashboard.
// Not in FilterBar.tsx: a component file that exports constants loses Fast
// Refresh, and the dashboard would remount on every edit to the bar.

export interface ActiveFilters {
  editorial_status: string[]
  priority: string[]
  asset_type: string[]
  tags: string[]
}

export const EMPTY_FILTERS: ActiveFilters = {
  editorial_status: [],
  priority: [],
  asset_type: [],
  tags: [],
}

export function hasActiveFilters(filters: ActiveFilters): boolean {
  return (
    filters.editorial_status.length > 0 ||
    filters.priority.length > 0 ||
    filters.asset_type.length > 0 ||
    filters.tags.length > 0
  )
}
